module.exports = __webpack_public_path__ + "static/media/wizualizacja-17.db3d6d3d.png";